var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category js-transition_item_common"},[_c('ul',{staticClass:"category__list"},_vm._l((_vm.links),function(item,index){return _c('li',{key:item.name,class:index == 0
          ? 'category__item js-category_item active'
          : 'category__item js-category_item',on:{"click":function($event){return _vm.onClick($event, item.name)}}},[_c('span',[_vm._v(_vm._s(item.renderName))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e6e5eea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/Category/_index.vue
// module id = null
// module chunks = 